export { default } from './cardan-form-license-plate';